import { render } from "./ContextNotifications.vue?vue&type=template&id=9a5af858"
import script from "./ContextNotifications.vue?vue&type=script&lang=js"
export * from "./ContextNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__